import { Link } from 'react-router-dom'
import { ShoppingCart } from 'lucide-react'
import { formatVND } from '@/lib/formatters'
import { useCartStore } from '@/modules/cart'
import type { Product } from '../../model/types'
import { StarRating } from './StarRating'

export function ProductCard({ product }: { product: Product }) {
  const addItem = useCartStore((s) => s.addItem)

  const handleAdd = () => {
    if (!product.inStock) return
    addItem({
      id: product.id,
      slug: product.slug,
      name: product.name,
      brand: product.brand,
      image: product.image,
      price: product.price,
      oldPrice: product.oldPrice,
      qty: 1,
    })
  }

  return (
    <div className="bg-surface border border-border rounded-xl overflow-hidden shadow-card hover:shadow-hover transition group flex flex-col">
      <div className="relative aspect-[4/3] bg-slate-100 overflow-hidden">
        {product.discountPct > 0 && (
          <span className="absolute top-3 left-3 z-10 bg-brand-600 text-white text-xs font-semibold px-2.5 py-1 rounded-full">
            -{product.discountPct}%
          </span>
        )}
        {!product.inStock && (
          <span className="absolute top-3 right-3 z-10 bg-slate-700 text-white text-[11px] font-medium px-2 py-1 rounded">
            Hết hàng
          </span>
        )}
        <Link to={`/san-pham/${product.slug}`}>
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
            onError={(e) => {
              (e.target as HTMLImageElement).src =
                'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 3"><rect width="4" height="3" fill="%23e2e8f0"/></svg>'
            }}
          />
        </Link>
      </div>

      <div className="p-4 flex flex-col flex-1">
        <div className="text-[11px] text-muted uppercase tracking-wide">{product.brand}</div>
        <Link
          to={`/san-pham/${product.slug}`}
          className="mt-1 text-[15px] font-semibold text-text line-clamp-2 hover:text-brand-600 transition min-h-[44px]"
        >
          {product.name}
        </Link>

        <div className="mt-2 flex items-center gap-2">
          <span className="text-muted text-[13px] line-through">{formatVND(product.oldPrice)}</span>
          <span className="text-brand-600 font-bold text-[17px]">{formatVND(product.price)}</span>
        </div>

        <div className="mt-2">
          <StarRating value={product.rating} reviews={product.reviews} />
        </div>

        <button
          type="button"
          onClick={handleAdd}
          disabled={!product.inStock}
          className="mt-4 w-full h-10 rounded-md bg-brand-600 hover:bg-brand-700 disabled:bg-slate-300 disabled:cursor-not-allowed text-white text-sm font-medium flex items-center justify-center gap-2 transition"
        >
          <ShoppingCart className="w-4 h-4" />
          {product.inStock ? 'Thêm vào giỏ' : 'Hết hàng'}
        </button>
      </div>
    </div>
  )
}
